export default __webpack_public_path__ + "static/media/tile-des1-en.b15be7f2.gif";